import React, { FC, ReactNode } from 'react';
import { classnames } from '@/utils/classnames';

export interface IHamiUserBalanceProps {
  isMasked?: boolean;
  amount: ReactNode;
  currency: ReactNode;
}

const HamiUserBalance: FC<IHamiUserBalanceProps> = ({
  isMasked,
  amount,
  currency,
}) => {
  return (
    <div className="flex items-center">
      <span
        className={classnames(
          'ml-1 text-lg font-demibold ltr',
          isMasked && 'relative top-[3px]'
        )}
      >
        {isMasked ? '**********' : amount}
      </span>
      <span className="z-[10] text-sm font-regular !text-gray-50 opacity-70">
        {currency}
      </span>
    </div>
  );
};
export { HamiUserBalance };
